import React from 'react';
import { useParams } from 'react-router-dom';

import { Text, Box, Title, Button, createStyles, Group, Anchor, Divider } from '@mantine/core';

const ChangePassword = () => {
  return (
    <Box>
      <Title order={1}>Change Password</Title>
      <Divider my="lg" />
      <Text>
        If you know your password and wish to change it, please use the{' '}
        <Anchor color="blue" href="https://reset.lh.ca">
          Password Reset Tool
        </Anchor>{' '}
        to change your password.
      </Text>
      <Text my="md">
        However, if you have forgotten your password, please contact the IT Service Desk at:{' '}
        <Anchor color="blue" href="tel:905-576-8711p34357">
          905-576-8711 (34357)
        </Anchor>
      </Text>
    </Box>
  );
};

export default ChangePassword;
